import { HandledError, RequestError, isDomainError, isValidationError } from '@synergy/api';

import { EmailErrorCode } from '../models/email-error-code';
import { ErrorMessage } from '../../../common/models/enums/error-message';

export const EmailErrorHandler = (error?: RequestError) => {
    const errors: HandledError<EmailErrorCode>[] = [];
    if (isValidationError(error)) {
        for (const violation of error.violations ?? []) {
            if (violation.propertyPath === 'mainEmail') {
                errors.push({
                    property: violation.propertyPath,
                    error: EmailErrorCode.MainEmailInvalid,
                });
            } else if (violation.propertyPath.startsWith('emails')) {
                errors.push({ property: violation.propertyPath, error: EmailErrorCode.EmailInvalid });
            }
        }
    } else if (isDomainError(error)) {
        if (error.title === ErrorMessage.NonUniqueProperties) {
            errors.push({ property: 'mainEmail', error: EmailErrorCode.MainEmailNotUnique, context: error.context });
        }
    }
    return errors;
};
